import React, { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'

import {
  useSelectedVisibleIndex,
  useVisibleFilters,
} from '../hooks/useVisibleFilters'
import {
  T_Filter,
  T_FilterSection,
  useFiltersStore,
} from '../state/filtersStore'
import { useNavigationStore } from '../state/navigationStore'

const FilterSections = () => {
  const visibleFilters = useVisibleFilters()
  const selectedVisibleIndex = useSelectedVisibleIndex()

  const { filterSections } = useFiltersStore(
    useShallow((state) => ({
      filterSections: state.filterSections,
    }))
  )

  const filtersBySection = useMemo(() => {
    const map = new Map<string, T_Filter[]>()
    for (const f of visibleFilters) {
      const arr = map.get(f.section_id)
      if (arr) arr.push(f)
      else map.set(f.section_id, [f])
    }
    return map
  }, [visibleFilters])

  return (
    <div className='filter-sections'>
      {filterSections.map((section) => (
        <FilterSection
          key={section.id}
          section={section}
          filters={filtersBySection.get(section.id) || []}
        />
      ))}
    </div>
  )
}

const FilterSection = ({
  section,
  filters,
}: {
  section: T_FilterSection
  filters: T_Filter[]
}) => {
  const { title, icon } = section

  return (
    <div className='filter-sections__section'>
      <div className='filter-sections__section-title'>
        <i className={`fa-solid ${icon}`}></i>
        <p>{title}</p>
      </div>

      <ul className='filter-sections__filter-list'>
        {filters.map((filter) => (
          <FilterSectionFilter key={filter.acf_name} filter={filter} />
        ))}
      </ul>
    </div>
  )
}

const FilterSectionFilter = ({ filter }: { filter: T_Filter }) => {
  const { label, short_description } = filter

  const { setSelectedFilter, appliedFilters } = useFiltersStore(
    useShallow((state) => ({
      setSelectedFilter: state.setSelectedFilter,
      appliedFilters: state.appliedFilters,
    }))
  )

  const setFilterPanelOpen = useNavigationStore(
    (state) => state.setFilterPanelOpen
  )

  const foundAlreadyAppliedFilter = appliedFilters.find(
    (f) => f.acf_name === filter.acf_name
  )

  return (
    <li
      className={[
        'filter-sections__filter-list-item',
        foundAlreadyAppliedFilter &&
          'filter-sections__filter-list-item--active',
      ].join(' ')}
    >
      <button
        onClick={() => {
          setSelectedFilter(filter)
          setFilterPanelOpen(true)
        }}
      >
        <div className='with-tooptip-wrapper'>
          <i className='fa-solid fa-circle-info'></i>
          <span>{short_description}</span>
        </div>

        <span>{label}</span>

        <div className='with-line-wrapper'>
          {foundAlreadyAppliedFilter ? (
            <i className='fa-solid fa-pen'></i>
          ) : (
            <i className='fa-solid fa-plus'></i>
          )}
        </div>
      </button>
    </li>
  )
}

export { FilterSections }
